import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const PlusOutlinedSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4311_41361)">
      <path
        d="M16.9285 11.1429H12.8571V7.07146C12.8571 6.95361 12.7607 6.85718 12.6428 6.85718H11.3571C11.2393 6.85718 11.1428 6.95361 11.1428 7.07146V11.1429H7.0714C6.95355
        11.1429 6.85712 11.2393 6.85712 11.3572V12.6429C6.85712 12.7607 6.95355 12.8572 7.0714 12.8572H11.1428V16.9286C11.1428 17.0465 11.2393 17.1429 11.3571 17.1429H12.6428C12.7607
        17.1429 12.8571 17.0465 12.8571 16.9286V12.8572H16.9285C17.0464 12.8572 17.1428 12.7607 17.1428 12.6429V11.3572C17.1428 11.2393 17.0464 11.1429 16.9285 11.1429Z"
        fill="currentColor"
      />
      <path
        d="M12 0C5.37321 0 0 5.37321 0 12C0 18.6268 5.37321 24 12 24C18.6268 24 24 18.6268 24 12C24 5.37321 18.6268 0 12 0ZM12 21.9643C6.49821 21.9643 2.03571 17.5018 2.03571
        12C2.03571 6.49821 6.49821 2.03571 12 2.03571C17.5018 2.03571 21.9643 6.49821 21.9643 12C21.9643 17.5018 17.5018 21.9643 12 21.9643Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4311_41361">
        <rect width="24" height="24" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

const PlusOutlined = (props: IIconProps) => <Icon component={PlusOutlinedSvg} {...props} />;

export default PlusOutlined;
